import { useState } from "@hookstate/core";
import { state } from "./state";

export const useMessageSentDialog = () => {
  return useState(state.messageSentDialog);
};
